import { render, staticRenderFns } from "./connect.page.vue?vue&type=template&id=41e81b76&scoped=true&"
import script from "./connect.page.vue?vue&type=script&lang=js&"
export * from "./connect.page.vue?vue&type=script&lang=js&"
import style0 from "./connect.page.vue?vue&type=style&index=0&id=41e81b76&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41e81b76",
  null
  
)

export default component.exports